<div class="row mr-0">
    <div class="col-4">
        <div *ngIf="lastDocumentQueryDate !== undefined && lastDocumentQueryDate !== null">
            <div>
                <span>{{ 'LAST-QUERY-DATE' | translate}}:</span>
                <br />
                <span style="font-size:smaller">{{lastDocumentQueryDate | date:"EEEE, MMMM d, y, h:mm:ss a"}}</span>
            </div>
            <div *ngIf="lastDocumentQuery && lastDocumentQuery.errorCode" class="pt-2">
                <span>{{ 'STATUS' | translate}}:</span>
                <span class="badge badge-pill text-uppercase query-error ml-2"
                    title="{{getErrorText(lastDocumentQuery.errorCode)}}">{{'DOCUMENT-QUERY-ERROR-STATUS' | translate}}
                </span>
            </div>
        </div>
    </div>
    <div class="col-8 m-0">
        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
            <app-advanced-mode id="clinicalRecordsGridAdvancedSwitch" [storageKey]="'clinical-records-list'"
                (collapsibleToggle)="enableAdvanced=$event">
            </app-advanced-mode>
            <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
            <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
        </div>
    </div>
</div>
<div class="mt-3 mb-3">
    <kendo-grid [data]="view.gridData" [loading]="view.loading"
        [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
        [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
        [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups"
        [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
        [reorderable]="enableAdvanced" (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)">
        <kendo-grid-messages noRecords="{{ 'NO-CLINICAL-RECORDS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column field="community" [width]="8" title="{{ 'DOCUMENT-SOURCE' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column field="name" [width]="20" title="{{ 'NAME' | translate }}"
            class="font-weight-bold emphasizedLabel" class="font-weight-bold emphasizedLabel">
            <ng-template kendoGridCellTemplate let-dataItem>
                <a class="pointer"
                    (click)="viewHandler(dataItem['id'], dataItem['name'], dataItem['fileType'], dataItem['createdDate'])">
                    {{ dataItem.name }}
                </a>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="documentClass" [width]="15" title="{{ 'DOCUMENT-CLASS' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column field="authorPerson" [width]="12" title="{{ 'DOCUMENT-AUTHOR-PERSON' | translate }}"
            [hidden]="true">
        </kendo-grid-column>
        <kendo-grid-column field="authorInstitution" [width]="15"
            title="{{ 'DOCUMENT-AUTHOR-INSTITUTION' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column field="createdDate" [width]="12" title="{{ 'CREATED-DATE' | translate }}" filter="date"
            format="{0:g}">
        </kendo-grid-column>
        <kendo-grid-column field="fileType" [width]="12" title="{{ 'DOCUMENT-TYPE' | translate }}" [hidden]="true">
        </kendo-grid-column>
        <kendo-grid-column field="fileSize" [width]="6" title="{{ 'SIZE' | translate }}" [hidden]="true">
        </kendo-grid-column>
    </kendo-grid>
</div>

<app-document-viewer #documentViewer></app-document-viewer>